(ns motorsaif.web.photos
  (:require
   [reagent.core :as r]
   [reagent.ratom :as ra]
   ["react" :as react]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   ["photoswipe$default" :as ps]
   [goog.functions :refer [debounce]]
   [motorsaif.string :refer [format]]
   [motorsaif.log :as log]
   [motorsaif.url :as url]))

;; PW

(defn thumbnail-src [request]
  (when-let [media (first (:request/media request))]
    (url/uploaded-media {:media media
                         :size :med})))

(defn photoswipe
  ([media] (photoswipe 0 media))
  ([pos media]
   (let [opts (clj->js {:index pos})
         media (sort-by :media/order media)
         ps (ps. opts)
         ds (clj->js (map-indexed
                      (fn [idx itm]
                        (let [img (js/Image.)
                              thumb (url/uploaded-media {:media itm :size :med})
                              full (url/uploaded-media {:media itm})
                              ;; full "https://dummyimage.com/1500x1000/555/fff/?text=1500x1000"
                              srcset (format "%s 1500w, %s 2000w" thumb full)

                              dims #js {:srcset srcset
                                        ;; :width 200
                                        ;; :height 200
                                        :msrc thumb ; necessary?
                                        :src thumb}]
                          (set! (.-onload img) #(do
                                                  (doto dims
                                                    (set! -width  (.-naturalWidth img))
                                                    (set! -height (.-naturalHeight img)))
                                                  (.refreshSlideContent ps idx)))
                          (set! (.-src img) thumb)
                          dims)) media))]
     (.on ps "beforeOpen" #(set! (.-options.dataSource ps) ds))
     (rf/dispatch [:page/on-change-once #(.destroy ps)])
     (.init ps))))

(defn carousel [{:keys [media gallery]}]
  (let [shown-media (take 5 (sort-by :media/order media))
        ref (react/createRef)
        *img-idx (r/atom 0)

        *scroll-container (atom nil)

        *img-array (atom nil)
        gen-img-array (fn []
                        (reset! *img-array
                                (mapv (fn [i] (* i (+ 10 ; margin-right from CSS
                                                      (.-clientWidth (.-current ref)))))
                                      (range (count shown-media)))))

        ;; _ (def hae ref)
        on-scroll (debounce (fn [sl]
                              (let [img-array (or @*img-array (gen-img-array)) ]
                                (let [slack 30
                                      found-offset (first (filter #(<= (- sl slack) % (+ sl slack)) img-array))]
                                  (when found-offset
                                    (reset! *img-idx (.indexOf img-array found-offset))))))
                            15)]
    (r/create-class
      {:reagent-render
       (fn [{:keys [id]}]
         [:div.mobile-non-expanded-photos
          {:ref ref}
          [:div.wrapper
           (into [:div.images.hide-bar
                  {:ref (fn [c]
                          (when c
                            (reset! *scroll-container c)))
                   :on-scroll #(on-scroll (.-scrollLeft (.-target %)))}]
                 (map-indexed
                  (fn [idx img]
                    [(fn [img]
                       [:div.wrap
                        [:img
                         (-> {:src (url/uploaded-media {:media img :size :med})
                              :on-load
                              (fn [_]
                                (when (= (count shown-media)
                                         (count @*img-array))
                                  (set! (.-scrollLeft @*scroll-container) 0)))}
                             (cond-> gallery
                               (assoc :on-click #(photoswipe idx media))))]])
                     img])
                  shown-media))]
          (when (> (count media) 1)
            [(fn [img-array]
               (into [:div.dots]
                     (map (fn [idx]
                            [:span.dot
                             {:class (when (= idx @*img-idx) "active")}])
                          (range (count media))))) @*img-array])])})))
